import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { HttpStatusCode } from 'axios';
import { GrossRevenueByAdvisors } from '../../dashboard-interfaces/gross-revenue-by-advisors.interface';
import { DashboardManagerTeamService } from '../../dashboard-services/dashboard-manager-team/dashboard-manager-team.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-gross-revenue-manager-advisors',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    ReactiveFormsModule,
    MatDividerModule
  ],
  templateUrl: './view-gross-revenue-manager-advisors.dialog.html',
  styleUrl: './view-gross-revenue-manager-advisors.dialog.scss'
})
export class ViewGrossRevenueManagerAdvisorsDialog implements OnInit, AfterViewInit {

  private router = inject(Router);
  private snackBarService = inject(SnackbarService);
  private dashboardManagerTeamService = inject(DashboardManagerTeamService);

  private grossRevenueByAdvisorData: GrossRevenueByAdvisors[] = [];
  protected grossRevenueByAdvisorTableDisplayColumn: string[] = ["repCode", "personName", "lifeInsuranceYtd", "investmentYtd", "generalInsuranceYtd", "feeAndReferralYtd", "totalGrossRevenueYtd"];
  protected grossRevenueByAdvisorTableDataSource = new MatTableDataSource<GrossRevenueByAdvisors>();

  grossRevenueByAdvisorTableFilterFc = new FormControl("");

  @ViewChild('grossRevenueByAdvisorTablePaginator')
  grossRevenueByAdvisorTablePaginator!: MatPaginator;
  @ViewChild('grossRevenueByAdvisorTableSort')
  grossRevenueByAdvisorTableSort = new MatSort();

  protected managerRepCode: string = "";
  protected managerName: string = "";

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public matData: any
  ) { }

  async ngOnInit(): Promise<void> {
    this.managerRepCode = this.matData.managerRepCode;
    this.managerName = this.matData.managerName;

    await this.getDashboardDataByBranchAdvisors(this.managerRepCode);

    this.grossRevenueByAdvisorTableDataSource.data = this.grossRevenueByAdvisorData;
  }

  ngAfterViewInit(): void {
    this.grossRevenueByAdvisorTableDataSource.paginator = this.grossRevenueByAdvisorTablePaginator;
    this.grossRevenueByAdvisorTableDataSource.sort = this.grossRevenueByAdvisorTableSort;
  }

  private async getDashboardDataByBranchAdvisors(managerRepCode: string) {
    const responseData = await this.dashboardManagerTeamService
      .getDashboardGrossRevenueManagerwiseAdvisors(managerRepCode)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        console.error(error);
        return error;
      });

    if (responseData.status === HttpStatusCode.Ok) {
      const advisorData: any[] = responseData.data.responsedata;
      advisorData.forEach((advisorItem) => {
        this.grossRevenueByAdvisorData.push({
          repCode: advisorItem.piasRepCode.toString(),
          personName: advisorItem.agentRealName.toString() || advisorItem.agentPreferredName.toString(),
          branch: advisorItem.branch.toString(),
          lifeInsuranceYtd: advisorItem.grossRevenueTotLifeInsurance.toString(),
          investmentYtd: advisorItem.grossRevenueTotInvestment.toString(),
          generalInsuranceYtd: advisorItem.grossRevenueTotGi.toString(),
          feeAndReferralYtd: advisorItem.grossRevenueTotFeeAndReferral.toString(),
          totalGrossRevenueYtd: advisorItem.grossRevenueTot.toString(),
          userGroup: advisorItem.userGroup.toString()
        })
      });

      this.grossRevenueByAdvisorData = this.grossRevenueByAdvisorData.filter(item => item.userGroup !== 'Affinity');
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("Something went wrong!!!");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  protected clearSearchField() {
    this.grossRevenueByAdvisorTableFilterFc.setValue('');
    this.__applyGrossRevenueByAdvisorDataFilter();
  }

  protected __applyGrossRevenueByAdvisorDataFilter() {
    let filterValue: string = this.grossRevenueByAdvisorTableFilterFc.value?.toString() || '';

    let tempGrossRevenueByAdvisorTableData: GrossRevenueByAdvisors[] = [];

    if (filterValue) {
      tempGrossRevenueByAdvisorTableData = this.grossRevenueByAdvisorData.filter(grData =>
        grData.repCode.toLowerCase().includes(filterValue.toLowerCase())
        || grData.personName.toLowerCase().includes(filterValue.toLowerCase()
        ));
    } else {
      tempGrossRevenueByAdvisorTableData = this.grossRevenueByAdvisorData;
    }

    this.grossRevenueByAdvisorTableDataSource.data = tempGrossRevenueByAdvisorTableData;
  }

}
